<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="visible"
    :show-close="false"
    width="800px">
    <div class="base-info-wrap">
      <div v-for="(levelInfo,index) in schoolBaseInfo" :key="index" class="level-wrap">
        <div>
          <el-checkbox disabled v-model="levelInfo.includeLevel">我们有{{levelInfo.levelName}}</el-checkbox>
        </div>
        <div class="level-title-wrap">
          <label style="margin-left: 7px;">年级</label>
          <label style="margin-left: 15px;">班级数量</label>
        </div>
        <div class="grade-info-wrap" v-for="(gradeInfo,gradeIndex) in levelInfo.grades" :key="gradeIndex">
          <label>{{gradeInfo.gradeName}}</label>
          <el-input-number :disabled="!levelInfo.includeLevel" style="width:100px;" :min="min" :max="100" v-model="gradeInfo.classCnt" :step="1" :controls="false" step-strictly></el-input-number>
          <label>个班</label>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="handleSave" :loading="handleLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { initSchoolBaseInfo } from '@/model/customer-manager-model'
import common from '@/util/common'
export default {
  name: 'InitSchoolBaseInfoDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      min: 0,
      dialogTitle: '学校信息初始化',
      handleLoading: false,
      schoolBaseInfo: [
        {
          includeLevel: false,
          levelType: 'primary',
          levelName: '小学',
          grades: [
            {
              gradeId: '1',
              gradeName: '小一',
              classCnt: 0
            },
            {
              gradeId: '2',
              gradeName: '小二',
              classCnt: 0
            },
            {
              gradeId: '3',
              gradeName: '小三',
              classCnt: 0
            },
            {
              gradeId: '4',
              gradeName: '小四',
              classCnt: 0
            },
            {
              gradeId: '5',
              gradeName: '小五',
              classCnt: 0
            },
            {
              gradeId: '6',
              gradeName: '小六',
              classCnt: 0
            }
          ]
        },
        {
          includeLevel: false,
          levelType: 'junior',
          levelName: '初中',
          grades: [
            {
              gradeId: '7',
              gradeName: '初一',
              classCnt: 0
            },
            {
              gradeId: '8',
              gradeName: '初二',
              classCnt: 0
            },
            {
              gradeId: '9',
              gradeName: '初三',
              classCnt: 0
            }
          ]
        },
        {
          includeLevel: false,
          levelType: 'high',
          levelName: '高中',
          grades: [
            {
              gradeId: '10',
              gradeName: '高一',
              classCnt: 0
            },
            {
              gradeId: '11',
              gradeName: '高二',
              classCnt: 0
            },
            {
              gradeId: '12',
              gradeName: '高三',
              classCnt: 0
            }
          ]
        }
      ],
      subjectLevel: [{
        label: '高中',
        value: 'high'
      }, {
        label: '初中',
        value: 'junior'
      }, {
        label: '小学',
        value: 'primary'
      }]
    }
  },
  computed: {
    schoolLevel () {
      return common.GetSchoolLevelArray(this.userInfo.organization.type)
    }
  },
  methods: {
    check () {
      let result = true
      for (let levelInfo of this.schoolBaseInfo) {
        if (levelInfo.includeLevel) {
          for (let gradeInfo of levelInfo.grades) {
            if (isNaN(gradeInfo.classCnt)) {
              console.log(gradeInfo)
              result = false
            }
          }
        }
      }
      return result
    },
    handleSave () {
      if (this.check()) {
        this.handleLoading = true
        let schoolBaseInfoParam = {
          orgid: this.userInfo.origanization,
          schoolname: this.userInfo.origanizationName,
          baseinfo: {
            primary: [0, 0, 0, 0, 0, 0],
            junior: [0, 0, 0],
            high: [0, 0, 0]
          }
        }
        for (let levelInfo of this.schoolBaseInfo) {
          if (levelInfo.includeLevel) {
            switch (levelInfo.levelType) {
              case 'high':
                schoolBaseInfoParam.baseinfo.high = Array.from(levelInfo.grades, (gradeInfo) => {
                  return gradeInfo.classCnt
                })
                break
              case 'junior':
                schoolBaseInfoParam.baseinfo.junior = Array.from(levelInfo.grades, (gradeInfo) => {
                  return gradeInfo.classCnt
                })
                break
              case 'primary':
                schoolBaseInfoParam.baseinfo.primary = Array.from(levelInfo.grades, (gradeInfo) => {
                  return gradeInfo.classCnt
                })
            }
          }
        }
        // 调用api
        initSchoolBaseInfo(schoolBaseInfoParam).then(res => {
          this.handleLoading = false
          if (res.result === 'true') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.$emit('oprate-success')
          } else {
            this.$message.error('操作失败，请稍后再试')
          }
        })
      } else {
        this.$message.error('请输入班级数量')
      }
    }
  },
  mounted () {
    for (let levelInfo of this.schoolBaseInfo) {
      levelInfo.includeLevel = this.schoolLevel.includes(levelInfo.levelType)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-info-wrap{
  display: flex;
  justify-content: space-between;
  .level-wrap{
    display: flex;
    width: 200px;
    flex-direction: column;
    padding: 15px;
    box-shadow: 0 0 3px 0px #d0c2c2;
    border-radius: 3px;
    flex-direction: column;
    .level-title-wrap{
      display: flex;
      align-items: center;
      height: 30px;
      margin-top: 10px;
      border-bottom: 1px solid $color-success;
    }
    .grade-info-wrap{
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/class/InitSchoolBaseInfoDialog.vue